import { useFetcher } from "~/hooks/useFetcher";

const { VITE_CATALOG_API } = import.meta.env;

const useColumnDatatypes = () => {
  return useFetcher<string[]>(`${VITE_CATALOG_API}/ingests/datatypes`);
};

export default useColumnDatatypes;
